export const SHOW_FADE_CARREGANDO = 'SHOW_FADE_CARREGANDO';
export const showFadeCarregando = (showCarregando) => ({
    type: SHOW_FADE_CARREGANDO,
    payload: {
        showCarregando: showCarregando
    }
});
export const RECEBIMENTO_FINALIZADO = 'RECEBIMENTO_FINALIZADO';
export const recebimentoFinalizado = (recebimentoFinalizado) => ({
    type: RECEBIMENTO_FINALIZADO,
    payload: {
        recebimentoFinalizado: recebimentoFinalizado
    }
});
export const PREENCHER_FILTRO = "PREENCHER_FILTRO";
export const preencherFiltro = (filtros) => ({
    type: PREENCHER_FILTRO,
    payload: {
        filtros: filtros
    }
});
export const PREENCHER_FAVORITOS = 'PREENCHER_FAVORITOS';
export const preencherFavoritos = (favoritos) => ({
    type: PREENCHER_FAVORITOS,
    payload: {
        favoritos: favoritos
    }
});
export const PREENCHER_LISTAGEM = "PREENCHER_LISTAGEM";
export const preencherListagem = (listagem) => ({
    type: PREENCHER_LISTAGEM,
    payload: {
        listagem: listagem
    }
});
export const ATUALIZAR_HEIGTH_FILTRO = "ATUALIZAR_HEIGTH_FILTRO";
export const atualizarHeigthFiltro = (altura) => ({
    type: ATUALIZAR_HEIGTH_FILTRO,
    payload: {
        altura: altura
    }
});
export const EXIBIR_DETALHE_ITEM = "EXIBIR_DETALHE_ITEM";
export const exibirDetalhesItem = (detalhes, topografias) => ({
    type: EXIBIR_DETALHE_ITEM,
    payload: {
        detalhes: detalhes,
        topografias: topografias
    }
});
export const ATUALIZAR_TOPOGRAFIAS = "ATUALIZAR_TOPOGRAFIAS";
export const atualizarTopografias = (topografias) => ({
    type: ATUALIZAR_TOPOGRAFIAS,
    payload: {
        topografias: topografias
    }
});
export const ATUALIZAR_DETALHES = "ATUALIZAR_DETALHES";
export const atualizarDetalhes = (detalhes) => ({
    type: ATUALIZAR_DETALHES,
    payload: {
        detalhes: detalhes
    }
});
export const VISIBILIDADE_MODAL = "VISIBILIDADE_MODAL";
export const visibilidadeModal = (visivel, itemClicado = undefined) => ({
    type: VISIBILIDADE_MODAL,
    payload: {
        visibilidade: visivel,
        itemClicado: itemClicado
    }
});
export const ATUALIZAR_TOTAIS_EXAMES = "ATUALIZAR_TOTAIS_EXAMES";
export const atualizarTotaisExames = (totalExamesAbertos, totalExamesConcluidos) => ({
    type: ATUALIZAR_TOTAIS_EXAMES,
    payload: {
        totalExamesAbertos: totalExamesAbertos,
        totalExamesConcluidos: totalExamesConcluidos
    }
});
export const MUDAR_TAB_ATIVA = "MUDAR_TAB_ATIVA";
export const mudarTabAtiva = (activeTab) => ({
    type: MUDAR_TAB_ATIVA,
    payload: {
        activeTab: activeTab
    }
});
export const PREENCHER_EXAMES_ABERTOS = "PREENCHER_EXAMES_ABERTOS";
export const preencherExamesEmAberto = (exames) => ({
    type: PREENCHER_EXAMES_ABERTOS,
    payload: {
        exames: exames
    }
});
export const TIPO_VINCULO_SELECIONADO = "TIPO_VINCULO_SELECIONADO";
export const tipoVinculoSelecionado = (tipo) => ({
    type: TIPO_VINCULO_SELECIONADO,
    payload: {
        tipo: tipo
    }
});
export const ESTADO_MENU_LATERAL = "ESTADO_MENU_LATERAL";
export const estadoMenuLateral = (collapsed) => ({
    type: ESTADO_MENU_LATERAL,
    payload: {
        collapsedMenu: collapsed
    }
});
export const IMPRIMI_ETIQUETA_CONTROLE = "IMPRIMI_ETIQUETA_CONTROLE";
export const imprimiEtiquetaControle = (imprimi) => ({
    type: IMPRIMI_ETIQUETA_CONTROLE,
    payload: {
        imprimiEtiquetaControle: imprimi
    }
});
export const EXIBIR_CHECKLIST_RECEBIMENTO = "EXIBIR_CHECKLIST_RECEBIMENTO";
export const exibirChecklistRecebimento = (exibir) => ({
    type: EXIBIR_CHECKLIST_RECEBIMENTO,
    payload: {
        exibirChecklistRecebimento: exibir
    }
});
export const EXIBIR_TELA_RECOLHIMENTO = "EXIBIR_TELA_RECOLHIMENTO";
export const exibirTelaRecolhimento = (exibir) => ({
    type: EXIBIR_TELA_RECOLHIMENTO,
    payload: {
        exibirTelaRecolhimento: exibir
    }
});
export const IMPRIMI_ETIQUETA_AGORA = "IMPRIMI_ETIQUETA_AGORA";
export const imprimiEtiquetaAgora = (imprimi) => ({
    type: IMPRIMI_ETIQUETA_AGORA,
    payload: {
        imprimiEtiquetaAgora: imprimi
    }
});
export const FATURAR_MEDICO_PADRAO = "FATURAR_MEDICO_PADRAO";
export const faturarMedicoPadrao = (faturar) => ({
    type: FATURAR_MEDICO_PADRAO,
    payload: {
        faturarMedicoPadrao: faturar
    }
});
export const MEDICO_EXECUTANTE_PADRAO = "MEDICO_EXECUTANTE_PADRAO";
export const medicoExecutantePadrao = (medico) => ({
    type: MEDICO_EXECUTANTE_PADRAO,
    payload: {
        medicoExecutantePadrao: medico
    }
});
export const ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES = "ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES";
export const atualizarListagemMultiplosExames = (listagem) => ({
    type: ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES,
    payload: {
        listagemMultiplosExames: listagem
    }
});
export const EXIBIR_MODAL_RECOLHIMENTO_LAUDO = "EXIBIR_MODAL_RECOLHIMENTO_LAUDO";
export const exibirModalRecolhimentoLaudo = (modalRecolhimento) => ({
    type: EXIBIR_MODAL_RECOLHIMENTO_LAUDO,
    payload: {
        modalRecolhimento: modalRecolhimento
    }
});
export const FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO = "FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO";
export const filtroLocalizacaoRegistroModalRecolhimento = (dados) => ({
    type: FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO,
    payload: {
        filtroLocalizacaoRegistroModalRecolhimento: dados
    }
});
export const ATUALIZAR_LAUDO_SELECIONADO = "ATUALIZAR_LAUDO_SELECIONADO";
export const atualizarLaudoSelecionado = (laudoSelecionado) => ({
    type: ATUALIZAR_LAUDO_SELECIONADO,
    payload: {
        laudoSelecionado: laudoSelecionado
    }
});
export const EXISTE_NAOCONFORMIDADE_IMPEDITIVA = "EXISTE_NAOCONFORMIDADE_IMPEDITIVA";
export const existeNaoConformidadeImpeditiva = (existeNaoConformidadeImpeditiva) => ({
    type: EXISTE_NAOCONFORMIDADE_IMPEDITIVA,
    payload: {
        existeNaoConformidadeImpeditiva: existeNaoConformidadeImpeditiva
    }
});
export const ALTERAR_TOPOGRAFIA_SELECIONADA = "ALTERAR_TOPOGRAFIA_SELECIONADA";
export const alterarTopografiaSelecionada = (topografiaselecionada) => ({
    type: ALTERAR_TOPOGRAFIA_SELECIONADA,
    payload: {
        topografiaselecionada: topografiaselecionada
    }
});
export const ALTERAR_QUANTIDADE_FRASCOS = "ALTERAR_QUANTIDADE_FRASCOS";
export const alterarQuantidadeFrascos = (quantidadeFrascos) => ({
    type: ALTERAR_QUANTIDADE_FRASCOS,
    payload: {
        quantidadeFrascos: quantidadeFrascos
    }
});

export const ATUALIZAR_MEDICOS = "ATUALIZAR_MEDICOS";
export const atualizarMedicos = (medicos) => ({
    type: ATUALIZAR_MEDICOS,
    payload: {
        medicos: medicos
    }
});

export const ALTERAR_MEDICO_MICROSCOPISTA_SELECIONADO = "ALTERAR_MEDICO_MICROSCOPISTA_SELECIONADO";
export const alterarMedicoMicroscopistaSelecionado = (medicoSelecionado) => ({
    type: ALTERAR_MEDICO_MICROSCOPISTA_SELECIONADO,
    payload: {
        medicoMicroscopistaSelecionado: medicoSelecionado
    }
});


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.action.js